import React, { Component } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { openChatHistory } from "../../actions/chathistory";
import { friendListSidebar, chatListSidebar } from "../../actions/sidebars";

class ProfileMessageDropdownComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      display: false,
      visible: false,
      parentHeight: 0,
      parentWidth: 0,
      directionY: "bottom",
      directionX: "left"
    };

    this.display = this.display.bind(this);
    this.showChatListSidebar = this.showChatListSidebar.bind(this);
    this.hideProxy = this.hideProxy.bind(this);
  }

  showChatListSidebar(profileDetail) {
    this.props.friendListSidebarClose();
    this.props.chatListSidebarOpen();
    this.props.openChatHistory(profileDetail);
  }

  display() {
    //update report player fields onclick
    //console.log(this.props.reporterId, this.props.reporteeId);
    // this.props.reportPlayerFormUpdateField("reporterId", this.props.reporterId);
    // this.props.reportPlayerFormUpdateField("reporteeId", this.props.reporteeId);
    // this.props.reportPlayerFormUpdateField("reason", "");

    // //update unfollow fields onclick
    // this.props.unfollowFormUpdateField("followerId", this.props.followerId);
    // this.props.unfollowFormUpdateField("followeeId", this.props.followeeId);
    // this.props.unfollowFormUpdateField("avatarUrl", this.props.avatarUrl);
    // this.props.unfollowFormUpdateField("userName", this.props.userName);

    this.setState((state, props) => {
      return {
        display: !state.display,
        parentHeight: this.parent.offsetHeight,
        parentWidth: this.parent.offsetWidth
      };
    });
    setTimeout(() => {
      this.setState((state, props) => {
        return {
          directionX:
            window.innerWidth -
              this.parent.offsetWidth -
              this.child.offsetWidth >
            this.parent.getBoundingClientRect().left
              ? "left"
              : "right",
          directionY: this.props.fixToBottom
            ? "top"
            : window.innerHeight -
                this.parent.offsetHeight -
                this.child.offsetHeight >
              this.parent.getBoundingClientRect().top
            ? "top"
            : "bottom",
          visible: !state.visible
        };
      });
    }, 20);
  }
  hideProxy = e => {
    if (
      (this.parent && this.parent.contains(e.target)) ||
      (this.child && this.child.contains(e.target))
    ) {
      return;
    }
    this.setState({
      display: false,
      visible: false,
      parentHeight: 0,
      parentWidth: 0,
      directionY: "bottom",
      directionX: "left"
    });
    return;
  };

  hideDropdown() {
    this.setState({
      display: false,
      visible: false
    });
  }

  componentWillMount() {
    document.addEventListener("mousedown", this.hideProxy, false);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.hideProxy, false);
  }
  render() {
    const { profiles } = this.props;
    return (
      <div className="dropdown">
        <div
          className="ripple-effect dropbtn"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          ref={ele => {
            this.parent = ele;
          }}
          onClick={this.display}
        >
          <span
            className={
              "btn  rounded-xs w-100 minw-180 " +
              (process.env.REACT_APP_PLATFORM === "nickx"
                ? "btn-orange"
                : "btn-secondary")
            }
          >
            Message
          </span>
        </div>

        <div
          className={
            (this.state.display
              ? "dropdown-content"
              : "dropdown-content-hidden") +
            (this.state.visible ? "" : " dropdown-content-not-visible")
          }
          style={
            this.state.display && this.state.visible
              ? {
                  [this.state.directionY]: this.state.parentHeight + "px",
                  [this.state.directionX]: "0px"
                }
              : {}
          }
          ref={ele => {
            this.child = ele;
          }}
        >
          {profiles.length ? (
            profiles.map((profile, index) => {
              return (
                <span
                  key={index}
                  className="a dropdown-item text-center text-center mb-1"
                  onClick={e => {
                    this.hideDropdown();
                    this.showChatListSidebar({
                      id: profile.id,
                      userName: profile.name,
                      profileUrl: profile.avatarUrl
                    });
                  }}
                >
                  {profile.name}
                </span>
              );
            })
          ) : (
            <></>
          )}

          <div
            className="border-line w-100 my-3"
            style={
              this.props.reporterId === this.props.reporteeId
                ? { display: "none" }
                : {}
            }
          />
          <div className="border-line w-100 my-3" />
          <span
            className="a dropdown-item text-center text-center text-center"
            onClick={() => {
              this.hideDropdown();
            }}
          >
            Cancel
          </span>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  openChatHistory: openChatHistory,
  friendListSidebarClose: friendListSidebar.close,
  chatListSidebarOpen: chatListSidebar.open
};

const mapStateToProps = state => {
  return {
    // isLoggedIn: state.user.isLoggedIn,
    // isAnyModalOpen: state.modals.isAnyModalOpen
  };
};
const defaultProps = {
  fixToBottom: false
};
ProfileMessageDropdownComponent.defaultProps = defaultProps;

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ProfileMessageDropdownComponent)
);
